export const environment = {
  production: false,
  appUrl: 'https://sso-backend.charity.griddynamics.net',
  prefix: '/api',
  local: true
};
